import { BlockPreContent } from './BlockPreContent'

export default BlockPreContent

export const dummyBlockPreContent = {
  subline: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr',
  headline: 'Lorem ipsum',
}
